export function formatDateTime(dateStr: string | null | undefined): string {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? dateStr : d.toLocaleString('es-AR');
}

export function formatMoney(amount: number | null | undefined): string {
    if (amount == null) return '—';
    return `$ ${amount.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** El monto declarado de caja es obligatorio y no puede ser negativo. */
export function isValidDeclaredAmount(amount: number | null | undefined): amount is number {
    return amount != null && amount >= 0;
}

const DISCREPANCY_THRESHOLD = 0.01;

/** Una diferencia (calculada por el backend) se considera discrepancia a partir de un centavo. */
export function hasDiscrepancy(differenceAmount: number | null | undefined): differenceAmount is number {
    return differenceAmount != null && Math.abs(differenceAmount) >= DISCREPANCY_THRESHOLD;
}

export function dateParam(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${m}-${d}T${hh}:${mm}:${ss}`;
}

export function startOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

export function endOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
}
